import * as React from "react";
import { SVGProps } from "react";
const SvgLogoXai = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-xai_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.203 0h3.376L8.593 9.975l-1.687-2.41L12.203 0Zm.887 16-.276-10.846 2.764-3.949L15.303 16H13.09ZM1 16h3.375l1.688-2.41-1.688-2.41L1 16Zm7.595 0L1 5.154h3.375L11.97 16H8.595Z"
        fill="#000"
      />
    </g>
    <defs>
      <clipPath id="logo-xai_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoXai;
